export default __webpack_public_path__ + "static/media/pelizarinho 1.394b096d.svg";